// src/components/admin/forms/SectorForm.js
import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { DashboardContext } from "../../../contexts/AdminContext";
import FormNotification, {
  useFormNotification,
} from "../../common/FormNotification";

const SectorForm = ({ show, handleClose, initialData = null }) => {
  const { addSector, updateSector } = useContext(DashboardContext);

  const [formData, setFormData] = useState(
    initialData ? { ...initialData } : { name: "", description: "" }
  );
  const { notif, notifySuccess, notifyError, clearNotif } =
    useFormNotification();
  const [loading, setLoading] = useState(false);

  // Update formData ketika initialData berubah (misalnya ketika mengedit sektor yang berbeda)
  useEffect(() => {
    if (initialData) {
      setFormData({ ...initialData });
    } else {
      setFormData({ name: "", description: "" });
    }
    clearNotif();
  }, [initialData, show, clearNotif]);

  // Handle perubahan input form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    clearNotif();
    setLoading(true);

    try {
      let result;

      if (initialData) {
        // Update sektor yang ada
        // Pastikan pakai id sesuai backend, bukan _id kalau dari DB MySQL
        result = await updateSector(
          initialData.id || initialData._id,
          formData
        );
      } else {
        // Tambah sektor baru
        result = await addSector(formData);
      }

      if (result.success) {
        notifySuccess(
          initialData
            ? "Data sektor berhasil diperbarui."
            : "Sektor baru berhasil ditambahkan."
        );
        // Biarkan loading aktif hingga modal ditutup agar banner sukses terlihat.
        setTimeout(() => {
          setFormData({ name: "", description: "" });
          handleClose();
        }, 1300);
      } else {
        // Jika gagal, tampilkan pesan error
        notifyError(result.error || "Gagal menyimpan sektor");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error saat menyimpan sektor:", err);
      notifyError(err.message || "Terjadi kesalahan saat menyimpan sektor");
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Edit Sektor" : "Tambah Sektor Baru"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormNotification notif={notif} onClose={clearNotif} />
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nama</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Masukkan nama sektor"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formLeader">
            <Form.Label>Leader</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nama Leader"
              value={formData.leader || ""}
              onChange={(e) =>
                setFormData({ ...formData, leader: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Deskripsi</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              rows={3}
              placeholder="Masukkan deskripsi"
              value={formData.description}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
          <div className="text-end">
            <Button
              variant="secondary"
              className="me-2"
              onClick={handleClose}
              disabled={loading}
            >
              Batal
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Menyimpan..." : "Simpan"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SectorForm;
